// 全局loading状态
export const SET_LOADING = `SET_LOADING`;

// 改变token(权限)
export const CHANGE_TOKEN = `CHANGE_TOKEN`;